import './assets/styles/App.css';
import { Pricer } from './components/Organisms';

function App() {
  return (
    <>
      <Pricer />
    </>
  );
}

export default App;
